import React from 'react';

const VotesTab = ({ votes, setShowVoteModal, deleteVote }) => {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-white">Voting Records</h2>
        <button
          onClick={() => setShowVoteModal(true)}
          className="bg-green-500 hover:bg-green-600 text-black font-bold py-2 px-6 rounded-sm uppercase tracking-wider"
        >
          + Add Vote
        </button>
      </div>
      
      <div className="space-y-4">
        {votes.map((vote) => (
          <div key={vote.id} className="bg-gray-900 border border-gray-800 p-6 rounded-sm">
            <div className="flex justify-between items-start mb-2">
              <div>
                <p className="text-gray-500 text-xs font-mono mb-2">{vote.date}</p>
                <h3 className="text-white font-bold text-lg">{vote.motion}</h3>
              </div>
              <span className={`text-xs font-mono px-2 py-1 rounded ${
                vote.result.includes('CARRIED') ? 'bg-green-900 text-green-500' : 'bg-red-900 text-red-500'
              }`}>
                {vote.result}
              </span>
            </div>
            
            <div className="flex gap-4 text-sm text-gray-400 font-mono mb-4">
              <span>YES: {vote.yes_votes?.length || 0}</span>
              <span>NO: {vote.no_votes?.length || 0}</span>
              {vote.abstained_votes?.length > 0 && <span>ABSTAINED: {vote.abstained_votes.length}</span>}
              {vote.not_present_votes?.length > 0 && <span>ABSENT: {vote.not_present_votes.length}</span>}
            </div>
            
            {vote.pdf_link && (
              <a 
                href={vote.pdf_link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 text-sm font-mono underline mr-4"
              >
                View PDF
              </a>
            )}
            
            <button
              onClick={() => deleteVote(vote.id)}
              className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-sm text-sm font-mono uppercase"
            >
              Delete
            </button>
          </div>
        ))}
        
        {votes.length === 0 && (
          <div className="bg-gray-900 border border-gray-800 p-12 rounded-sm text-center">
            <p className="text-gray-500 font-mono">No voting records found</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default VotesTab;
